// extracted by mini-css-extract-plugin
export default {"GameSchedulesContainer":"GameSchedules_GameSchedulesContainer__nBA9V"};